export default __webpack_public_path__ + "static/media/thunder-bolt.8480415b.png";